import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop error in development mode
// This is a known harmless warning from React Flow and other libraries using ResizeObserver
// See: https://github.com/xyflow/xyflow/issues/3076
if (process.env.NODE_ENV === 'development') {
  const resizeObserverRegex =
    /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;

  window.addEventListener(
    'error',
    (event) => {
      const message = event?.message || '';
      if (resizeObserverRegex.test(message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
